// Copy of getRoleString from types/players.tsx: importing that module would pull the host app code into the TV page.
const ROLE_NAMES = {
    CIVILIAN: 'Мирный',
    MAFIA: 'Мафия',
    DON: 'Дон',
    SHERIFF: 'Шериф',
    DOCTOR: 'Доктор',
    MANIAC: 'Маньяк',
    LADY: 'Императрица',
    GAG: 'Затычка',
    SWITCHMAN: 'Стрелочник',
    BOMB: 'Зараженный',
    JAILER: 'Тюремщик',
    WEREWOLF: 'Оборотень',
    KAMIKADZE: 'Камикадзе',
    PROVOCATEUR: 'Агент провокатор',
    WIFE: 'Жена',
    HUSBAND: 'Муж',
    FOOL: 'Дурак',
    BACHELOR: 'Холостяк',
    ADVOCATE: 'Адвокат',
    INSTIGATOR: 'Подстрекатель',
};
export const roleName = (role) => { var _a; return (role ? (_a = ROLE_NAMES[role]) !== null && _a !== void 0 ? _a : 'Мирный' : ''); };
const EVENT_TEXT = {
    KILL: 'убит(а)',
    VOTES_KILL: 'покидает игру по итогам голосования',
    SAVED_BY_LADY: 'спасён Императрицей',
    JAILER_ARREST: 'садится в тюрьму',
    RELEASE_FROM_PRISON: 'выходит из тюрьмы',
    MAKE_SILENT: 'получает затычку',
    REVOKE_IMMUNITY: 'иммунитет снят',
    // Same as a kill: the club does not tell how the player died
    EXPLODE: 'убит(а)',
    FAMILY_KILL: 'уходит вслед за супругом',
    TECH_KILL: 'технический труп',
};
const DEATH_EVENTS = ['KILL', 'VOTES_KILL', 'EXPLODE', 'FAMILY_KILL', 'TECH_KILL'];
export const eventText = (type) => { var _a; return (_a = EVENT_TEXT[type]) !== null && _a !== void 0 ? _a : ''; };
export const isDeathEvent = (type) => DEATH_EVENTS.includes(type);
const WIN_TEXT = {
    CIVILIANS_WIN: 'Победили мирные',
    MAFIA_WIN: 'Победила мафия',
    FOOLS_WIN: 'Победили дураки',
    DRAW: 'Ничья',
};
export const winText = (winCase) => { var _a; return winCase ? (_a = WIN_TEXT[winCase]) !== null && _a !== void 0 ? _a : 'Игра окончена' : 'Игра окончена'; };
export const formatElapsed = (seconds) => {
    const safe = Math.max(0, Math.floor(seconds));
    const m = Math.floor(safe / 60);
    const s = safe % 60;
    return `${m}:${s < 10 ? '0' : ''}${s}`;
};
export const formatCode = (code) => (code.length === 6 ? `${code.slice(0, 3)}-${code.slice(3)}` : code);
export const joinNames = (names) => {
    if (names.length <= 1)
        return names.join('');
    return `${names.slice(0, -1).join(', ')} и ${names[names.length - 1]}`;
};
export const plural = (n, forms) => {
    const mod10 = n % 10;
    const mod100 = n % 100;
    if (mod10 === 1 && mod100 !== 11)
        return forms[0];
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14))
        return forms[1];
    return forms[2];
};
// Shrinks a font size for long strings so a nick never runs out of its box.
export const fitFontSize = (text, base, maxChars, min = 0.4) => {
    if (text.length <= maxChars)
        return base;
    return Math.max(Math.round(base * min), Math.floor((base * maxChars) / text.length));
};
